import React, { useEffect, useRef, useState } from 'react';
import Top from '../Top';
import Leftsiderbar from '../home/allcmp/Leftsidebar';
import { makeStyles } from "@material-ui/core/styles";
import { useNavigate } from 'react-router-dom';




const useStyles = makeStyles(() => ({
    customTooltip: {
        backgroundColor: "black",
        fontSize: "15px"
    }
}));
const CreateDevices = ()=>{
    const navigate = useNavigate();
    
    const classes = useStyles();
    const handleNewDevice = ()=>{
        navigate('/add-device');

    }

    return(
        <div className="">
            <div className="cmail">
                <Top />
            </div>
            <div className="wrp-dashbord">
                <div className="cemail-left">
                    <Leftsiderbar />
                </div>
                <div className="right-section">
                    <div className="add-btn-wrp add-btn-wrp2">
                        <div className='button-div'>
                        <button className='create-button' onClick={handleNewDevice}>New Devices</button>
                        <button className='create-button'>Edit Devices</button>
                        </div>    
                    </div>
                </div>
            </div>

        </div>
    )
}
export default CreateDevices;